import { ComponentCategory, ComponentOption } from "@/types/types";

const baseGpus: Omit<ComponentOption, 'socketType' | 'modelPath' | 'scale' | 'category'>[] = [
  {
    id: "gpu-1",
    name: "NVIDIA RTX 5060TI - 8GB",
    brand: "NVIDIA",
    price: 525,
    pcieGen: 5,
    amazonLink: "#",
    wattage: 650,
    specs: {
      memory: "8GB GDDR6",
      boostClock: "2.57 GHz",
      rtCores: "36",
      tensorCores: "144",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rtx5060ti.gltf",
  },
  {
    id: "gpu-2",
    name: "NVIDIA RTX 5060 TI - 16GB",
    brand: "NVIDIA",
    price: 599.99,
    pcieGen: 5,
    amazonLink: "#",
    wattage: 650,
    specs: {
      memory: "16GB GDDR6X",
      boostClock: "2.57 GHz",
      rtCores: "36",
      tensorCores: "144",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rtx5060ti_16gb.gltf",
  },
  {
    id: "gpu-3",
    name: "NVIDIA RTX 5070",
    brand: "NVIDIA",
    price: 800,
    pcieGen: 5,
    amazonLink: "#",
    wattage: 700,
    specs: {
      memory: "12GB GDDR6X",
      boostClock: "2.6 GHz",
      rtCores: "48",
      tensorCores: "192",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rtx5070.gltf",
  },
  {
    id: "gpu-4",
    name: "NVIDIA RTX 5070 TI",
    brand: "NVIDIA",
    price: 1050,
    pcieGen: 5,
    amazonLink: "#",
    wattage: 700,
    powerConnectors: ['PCIE_8PIN'], // Defines the power input
    specs: {
      memory: "16GB GDDR6X",
      boostClock: "2.52 GHz",
      rtCores: "70",
      tensorCores: "280",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rtx5070ti.gltf",
  },
  {
    id: "gpu-5",
    name: "NVIDIA RTX 5080 ",
    brand: "NVIDIA",
    price: 1600,
    pcieGen: 5,
    amazonLink: "#",
    wattage: 850,
    specs: {
      memory: "16GB GDDR6X",
      boostClock: "2.52 GHz",
      rtCores: "84",
      tensorCores: "336",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rtx5080.gltf",
  },
  {
    id: "gpu-6",
    name: "NVIDIA RTX 5090 ",
    brand: "NVIDIA",
    price: 3500,
    pcieGen: 5,
    amazonLink: "#",
    wattage: 1000,
    specs: {
      memory: "32GB GDDR6X",
      boostClock: "2.55 GHz",
      rtCores: "170",
      tensorCores: "680",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rtx5090.gltf",
  },
  {
    id: "gpu-7",
    name: "RX 9070XT ",
    brand: "AMD",
    price: 900,
    pcieGen: 5,
    amazonLink: "#",
    wattage: 800,
    specs: {
      memory: "8GB GDDR6",
      boostClock: "2044 GHz",
      rtCores: "28",
      computeUnits: "28",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rx9070xt.gltf",
  },
  {
    id: "gpu-8",
    name: "RX 6600 ",
    brand: "AMD",
    price: 225,
    pcieGen: 4,
    amazonLink: "#",
    wattage: 500,
    specs: {
      memory: "8GB GDDR6",
      boostClock: "2044 GHz",
      rtCores: "28",
      computeUnits: "28",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rx6600.gltf",
  },
  {
    id: "gpu-9",
    name: "RTX 2060 6GB ",
    brand: "NVIDIA",
    price: 550,
    pcieGen: 3,
    amazonLink: "#",
    wattage: 165,
    specs: {
      memory: "6GB GDDR6",
      boostClock: "2044 GHz",
      rtCores: "28",
      computeUnits: "28",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rtx2060.gltf",
  },
  {
    id: "gpu-10",
    name: "RTX 3060 12GB ",
    brand: "NVIDIA",
    price: 380,
    pcieGen: 4,
    amazonLink: "#",
    wattage: 550,
    specs: {
      memory: "12GB GDDR6",
      boostClock: "2044 GHz",
      rtCores: "28",
      computeUnits: "28",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rtx3060.gltf",
  },
  {
    id: "gpu-11",
    name: "RTX 4060 8GB ",
    brand: "NVIDIA",
    price: 460,
    pcieGen: 4,
    amazonLink: "#",
    wattage: 550,
    specs: {
      memory: "8GB GDDR6",
      boostClock: "2044 GHz",
      rtCores: "28",
      computeUnits: "28",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rtx4060.gltf",
  },
  {
    id: "gpu-12",
    name: "RX 9060XT",
    brand: "AMD",
    price: 369.99,
    pcieGen: 5,
    amazonLink: "https://amzn.to/443IYXE",
    wattage: 550,
    specs: {
      memory: "8GB GDDR6",
      boostClock: "2044 GHz",
      rtCores: "28",
      computeUnits: "28",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/rx9060xt.gltf",
  },
  {
    id: "gpu-13",
    name: "B580 - Bad Value",
    brand: "INTEL",
    price: 377,
    pcieGen: 4,
    amazonLink: "https://amzn.to/4l9o0xJ",
    wattage: 550,
    specs: {
      memory: "8GB GDDR6",
      boostClock: "2044 GHz",
      rtCores: "28",
      computeUnits: "28",
      rayTracingSupport: "Yes"
    },
    imageUrl: "",
    model_path: "/models/gpus/b580.gltf",
  }
];

export const gpuComponents: ComponentCategory = {
  id: "gpu",
  name: "Graphics Card (GPU)",
  description: "Powers the visual elements and graphics rendering for games and applications.",
  required: true,
  options: baseGpus.map(gpu => ({
    ...gpu,
    socketType: 'GPU_SLOT',
    scale: [0.08, 0.08, 0.08], // Placeholder scale for GPUs
    category: "gpu"
  })),
};

export const gpuData = baseGpus;
